<template>
  <div class="pwa-prompt-box">
    <div class="pwa-prompt-wrap" :class="{ 'active': deferredPrompt }">
      <!-- <span class="text">{{ $t('add_screen_des1') }} {{ $t('add_screen_des2') }}</span> -->
      <a href="javascript:;" class="btn btn-install" @click="goInstall">{{ $t('title_install_bonus') }}<em class="icon"></em></a>
    </div>
    <!-- 安装快捷方式弹窗 -->
    <PopupInstallBonus v-if="isShowPopupInstallBonus && deferredPrompt" @pwaInstall="goInstall('bonus')" :showType="popupType"></PopupInstallBonus>
    <ArrivalPanel :style="{ left: showArrivalPanel ? '0' : '101%' }" :is-show="showArrivalPanel" @click.native="showArrivalPanel = false" :options="{ type: 'pwa' }"></ArrivalPanel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ameApiDo } from '@/server/api'
import PopupInstallBonus from './popup/InstallBonus.vue'
import ArrivalPanel from './queuePopup/ArrivalPanel.vue'

export default {
  name: 'PwaPrompt',
  components: { PopupInstallBonus, ArrivalPanel },
  data () {
    return {
      isShowPopupInstallBonus: false,
      popupType: '',
      deferredPrompt: window.__deferredPrompt || undefined,
      busOpenidUpdated: false,
      busGameStart: false,
      showArrivalPanel: false
    }
  },
  created () {
    const ua = (navigator.userAgent || '').toLowerCase()
    ua.includes('chrome') && this.showPrompt()
    this.$bus.$on('open-install-bonus-popup', (data) => {
      this.$utils.consoleLog('bus on open-install-bonus-popup')
      this.handleInstallBonus(data, 'level')
    })
    this.$bus.$on('user-openid-updated', () => {
      this.busOpenidUpdated = true
      if (this.busGameStart) {
        this.handleInstallBonus({ level: 2 }, 'default')
      }
    })
    this.$bus.$on('button-gameStart-click', () => {
      this.busGameStart = true
      if (this.busOpenidUpdated) {
        this.handleInstallBonus({ level: 2 }, 'default')
      }
    })
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo'
    })
  },
  methods: {
    showPrompt () {
      console.log('==z==> showPrompt')
      window.addEventListener('beforeinstallprompt', (e) => {
        console.log('==z==> beforeinstallprompt')
        // 防止 Chrome 67 及更早版本自动显示安装提示
        e.preventDefault()
        // 稍后再触发此事件
        this.deferredPrompt = e
      })
    },
    goInstall (type) {
      this.deferredPrompt.prompt()
      // 等待用户反馈
      this.deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            this.$utils.consoleLog('pwa-install 确认安装')
            let saveChannel = 'directory'
            // 二级弹窗安装快捷方式奖励
            if (type === 'bonus') {
              saveChannel = 'level_2_popup'
              // 从奖励弹窗点击安装
              const params = {
                p0: 'web',
                p1: 18,
                p2: 1107,
                openid: this.userInfo.openid,
                device_id: this.$utils.getDeviceId()
              }
              ameApiDo(params)
                .then(res => {
                  this.isShowPopupInstallBonus = false
                  this.$utils.log('save_to_desktop_reward', { save_channel: 'level_2_popup' })
                })
                .catch(err => {
                  console.error(err)
                })
                .finally(() => {
                  this.$bus.$emit('welfare-check-ame-pwa')
                })
              this.$utils.log('webgame_shorcut_guide', { type: 'save_shortcut' })
            } else {
              // 顶栏按钮安装奖励
              if (this.userInfo.openid) {
                // 从奖励弹窗点击安装
                const params = {
                  p0: 'web',
                  p1: 18,
                  p2: 1107,
                  openid: this.userInfo.openid,
                  device_id: this.$utils.getDeviceId()
                }
                ameApiDo(params)
                  .then(res => {
                    this.showArrivalPanel = true
                    this.$utils.log('save_to_desktop_reward', { save_channel: 'directory' })
                    window.localStorage.setItem('_i_p_a_pwa_directory_', 2)
                  })
                  .catch(err => {
                    console.error(err)
                  })
              } else {
                window.localStorage.setItem('_i_p_a_pwa_directory_', 1)
              }
              this.$utils.log('save_to_desktop', { save_channel: saveChannel })
            }
          } else {
            this.$utils.consoleLog('pwa-install 取消安装')
          }
          this.deferredPrompt = undefined
        })
    },
    handleInstallBonus (mesgData, type) {
      this.$utils.consoleLog('handleInstallBonus ', mesgData)
      // 文档：https://funplus.yuque.com/sf1r4l/orh4er/iomklh76kspx1cqb?singleDoc#
      // if (localStorage.getItem('test_emit_install_bonus_popup')) this.isShowPopupInstallBonus = true
      // 判断已安装，不再提示
      const pwaDisplayMode = this.$utils.getPWADisplayMode
      if (pwaDisplayMode === 'standalone') return
      // 判断要塞到达2级
      if (!mesgData.level || Number(mesgData.level) !== 2) return
      const params = {
        p0: 'web',
        p1: 18,
        p2: 1106,
        openid: this.userInfo.openid,
        device_id: this.$utils.getDeviceId()
      }
      ameApiDo(params)
        .then(res => {
          if (res.is_add_desktop) return
          if (res.is_recevied) return
          // 安装快捷方式奖励
          this.popupType = type
          this.isShowPopupInstallBonus = true
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.pwa-prompt-box{
  .arrival-wrap{
    position: fixed;
    z-index: 5;
  }
}
.pwa-prompt-wrap{
  width: 170px;
  height: @headerH;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: flex-end;
  font-size: 16px;
  color: #B0B0B0;
  line-height: 22px;
  position: relative;
  left: 50%;
  top: -@headerH;
  opacity: 1;
  transition: all .3s;
  transform: translateX(-50%);
  & > *{
    // margin: 0 15px;
  }
  &.active{
    top: 0;
    opacity: 1;
  }
}
.btn-install{
  max-width: 250px;
  height: 36px;
  padding: 0 18px;
  font-weight: 500;
  color: #000;
  line-height: 16px;
  border-radius: 5px;
  background-color: #B4A36C;
  display: flex;
  align-items: center;
  position: relative;
  .icon{
    width: 38px;
    height: 30px;
    position: absolute;
    top: -6px;
    right: -15px;
    background: url(~@/assets/img/icon_pwa_directory.png) no-repeat center center;
    background-size: 100% 100%;
    transform: scale(0.9);
    animation: iconScale 3s linear 0s infinite;
  }
}

// 手机
@media screen and (max-width: 768px) {
  .pwa-prompt-wrap{
    height: @m_headerH;
    top: -@m_headerH;
    .text{
      display: none;
    }
    .btn-install{
      height: 40px;
      border-radius: 5px;
      line-height: 18px;
    }
  }
}

@keyframes iconScale {
  0% { transform: scale(0.9); }
  10% { transform: scale(0.75); }
  20% { transform: scale(1); }
  25% { transform: scale(0.8); }
  30% { transform: scale(0.9); }
  100% { transform: scale(0.9); }
}
</style>
